// src/components/WindRasterLayer.jsx
import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const RasterLayer = ({ view }) => {
  useEffect(() => {
    if (!view || !view.map) return;

    let windLayer;

    loadModules(['esri/layers/WMSLayer']).then(([WMSLayer]) => {
      windLayer = new WMSLayer({
        title: 'Rasters',
        url: 'https://portal.boom-h2-pipelines.com/geoserver/gt/wms?',
        visible: false
      });

      windLayer.load().then(() => {
        const sublayer = windLayer.findSublayerByName('ESP_wind_speed_10m');
        if (sublayer) {
          // Optional: configure or isolate the sublayer
          // windLayer.sublayers = [sublayer];
        }

        if (view.map) {
          view.map.add(windLayer);
        }
      });
    });

    return () => {
      if (windLayer && view?.map) {
        view.map.remove(windLayer);
      }
    };
  }, [view]);

  return null;
};

export default RasterLayer;
